import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Page';

const PageApi: any = baseApi(endpoint);

export default PageApi;